/**
 * Agency staff role -> i18n label key (`agency` namespace). SSOT for how the
 * brand-portfolio staff role is shown to people: the enum MEMBER is displayed as
 * "Specialist" (display only, no DB change). Brand-level team roles
 * (OWNER/ADMIN/MEMBER/REVIEWER in brand Team settings) are a different concept.
 */
export type AgencyRoleLabelKey =
  | 'agency_team_role_owner_label'
  | 'agency_team_role_admin_label'
  | 'agency_team_role_manager_label'
  | 'agency_team_role_user_label';

export function agencyRoleLabelKey(role: string): AgencyRoleLabelKey {
  switch (role.toLowerCase()) {
    case 'owner':
      return 'agency_team_role_owner_label';
    case 'admin':
      return 'agency_team_role_admin_label';
    case 'manager':
      return 'agency_team_role_manager_label';
    default:
      return 'agency_team_role_user_label';
  }
}

const AGENCY_ROLE_EN_LABEL: Record<AgencyRoleLabelKey, string> = {
  agency_team_role_owner_label: 'Owner',
  agency_team_role_admin_label: 'Admin',
  agency_team_role_manager_label: 'Manager',
  agency_team_role_user_label: 'Specialist',
};

/** English label for non-i18n contexts (super-admin pages). Never shows the raw enum. */
export function agencyRoleLabelEn(role: string): string {
  return AGENCY_ROLE_EN_LABEL[agencyRoleLabelKey(role)];
}
